var map = {
	"./lucky-tnc-cn.svg": 985,
	"./term-condition-bm.svg": 986,
	"./term-condition-cn.svg": 987,
	"./term-condition-id.svg": 988,
	"./term-condition-vn.svg": 989,
	"./term-condition.svg": 990,
	"./term-footer-m.jpg": 991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 984;